/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface SkillsWithOrigin
 */
export interface SkillsWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof SkillsWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof SkillsWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the SkillsWithOrigin interface.
 */
export function instanceOfSkillsWithOrigin(value: object): value is SkillsWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function SkillsWithOriginFromJSON(json: any): SkillsWithOrigin {
    return SkillsWithOriginFromJSONTyped(json, false);
}

export function SkillsWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillsWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function SkillsWithOriginToJSON(value?: SkillsWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

